import React from 'react';
import ReactDOM from 'react-dom';
import { Switch } from 'react-router-dom';
import {
    NavbarContainer,
    Footer,
    SkipNavContent,
    ErrorBoundary,
} from 'sarsaparilla';
import { AppBase, ErrorPage } from 'shared-ui';

import * as Env from './env';
import makeSwitchRoutes from './makeSwitchRoutes';


export default function App() {
    return (
        <AppBase>
            <NavbarContainer />
            <ErrorBoundary fallbackElement={<ErrorPage />}>
                <SkipNavContent>
                    <Switch>{makeSwitchRoutes()}</Switch>
                </SkipNavContent>
            </ErrorBoundary>
            <Footer />
        </AppBase>
    );
}

if (process.env.REACT_AXE_ENV === 'local' && Env.REACT_AXE_ENABLED) {
    // eslint-disable-next-line
    const axe = require('react-axe');
    axe(React, ReactDOM, 5000);
}
